import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import FinancialContent from '../page-content/financial/data-analysis-financial.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Hero = makeShortcode("Hero");
const MenuWrapperComponent = makeShortcode("MenuWrapperComponent");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Hero slots="heading" variant="fullwidth" theme="dark" customLayout className="herobgImage Hero-Banner" mdxType="Hero" />
    <h1 {...{
      "id": "acrobat-services-api-use-cases"
    }}>{`Acrobat Services API Use Cases`}</h1>
    <MenuWrapperComponent menuItem='subMenuPages' slots="content" repeat="1" theme="lightest" className="Data-Analysis-for-Finance" mdxType="MenuWrapperComponent" />
    <FinancialContent mdxType="FinancialContent" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      